<template>
  <div @click="closeModal" class="select-customer-modal">
    <div class="modal-popup" :class="{ loading: isLoading }">
      <button
        v-if="isCloseBtnDisplay"
        class="close-button"
        @click="$emit('exit-modal')"
      >
        ✕
      </button>
      <h1 class="felix007 center">אנא בחרו בלקוח</h1>

      <div class="customers-list">
        <div
          v-for="customer in customers"
          :key="customer.cust"
          class="customer-item"
          @click="selectCustomer(customer)"
          :disabled="isLoading"
        >
          <div class="customer-logo">
            <img
              src="../../assets/icons/customer-logo.svg"
              alt="Customer Logo"
            />
          </div>
          <div class="customer-info">
            <div class="customer-name">{{ customer.custname }}</div>
            <div class="customer-id">מספר לקוח: {{ customer.cust }}</div>
          </div>
        </div>
      </div>

      <div v-if="isLoading" class="loading-overlay">
        <div class="loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["select-customer", "exit-modal"],
  props: {
    customers: {
      type: Array,
      required: true,
    },
    isCloseBtnDisplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    closeModal() {
      if (this.isCloseBtnDisplay) this.$emit("exit-modal");
    },
    async selectCustomer(customer) {
      this.isLoading = true;
      this.$emit("select-customer", customer, this.stopLoading);
    },
    stopLoading() {
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.select-customer-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.backdrop-popup {
  background-color: #000000;
  opacity: 0.6;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 11;
}

.modal-popup {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  z-index: 12;
  font-size: $mediumTextSize;
  border-radius: 40px;
  background: #393945;
  padding: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px; // Increased width for better display
  max-height: 90vh;
  min-height: 400px; // Add minimum height
  height: auto;
  overflow: hidden; // Changed from overflow-y: auto

  /* Custom scrollbar styles */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  /* Firefox scrollbar styles */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;

  h1 {
    margin: 0;
    padding: 0;
    color: white;
    font-size: $largestTextSize;
    letter-spacing: 0.04px;
  }
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  color: #fff;
  font-size: 25px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0.15);
  }
}

.customers-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  overflow-y: auto;
}

.customer-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.customer-logo {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.customer-info {
  flex: 1;
  color: white;
}

.customer-name {
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 4px;
}

.customer-id {
  font-size: 0.9em;
  opacity: 0.7;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
}

.loader {
  width: 40px;
  height: 40px;
  border: 4px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
